import { get, post } from '@/services/API';

export default {
  postSearchResult: (searchResult) => post('/api/search-result/', { searchResult }),
  getMostViewed: () => get('/api/search-result/most-viewed'),
  getMostRecent: () => get('/api/search-result/most-recent'),
};
